
import SpriteRatingEmoji from "@/components/base/image/SpriteRatingEmoji"
import { mapGetters } from "vuex"

export default {
    name: "RatingSnackbar",
    components: { SpriteRatingEmoji },
    data: () => ({
        snackbar: false,
    }),
    watch: {
        lastRating(rating) {
            if (rating?.value > 50) {
                this.snackbar = true
            }
        },
    },
    computed: {
        ...mapGetters("rating", ["lastRating"]),
        currentIndex() {
            if (!this.lastRating) return 0
            const EMOJI_COUNT = 10
            return Math.min(
                Math.floor(this.lastRating.value / EMOJI_COUNT),
                EMOJI_COUNT - 1
            )
        },
    },
}
